import * as React from 'react';
import { Alert } from './feedback';

type Props = {
  children: React.ReactNode;
  /** Nome da parte, mostrado na mensagem ("Não foi possível mostrar Financeiro agora"). */
  titulo?: string;
  /** Registro do erro (Sentry). Quem usa decide para onde vai. */
  aoErro?: (erro: Error) => void;
  /** Quando muda (ex.: a rota), o erro é esquecido e o conteúdo tenta de novo. */
  chave?: string;
};

type Estado = { erro: Error | null; chave?: string };

// Depois de um deploy, a tela carregada sob demanda some do servidor; só recarregar resolve
const MODULO_NAO_CARREGOU = /dynamically imported module|Importing a module script failed/;

/** Isola falhas de tela: uma parte quebrada mostra um aviso e o resto continua funcionando. */
export class LimiteErro extends React.Component<Props, Estado> {
  override state: Estado = { erro: null, chave: this.props.chave };

  static getDerivedStateFromError(erro: Error): Partial<Estado> {
    return { erro };
  }

  static getDerivedStateFromProps(props: Props, estado: Estado): Partial<Estado> | null {
    return props.chave !== estado.chave ? { erro: null, chave: props.chave } : null;
  }

  override componentDidCatch(erro: Error) {
    this.props.aoErro?.(erro);
  }

  override render() {
    const { erro } = this.state;
    if (!erro) return this.props.children;
    const { titulo, aoErro } = this.props;
    const recarregar = MODULO_NAO_CARREGOU.test(erro.message);
    return (
      <Alert variant="erro">
        <div className="flex-1">
          <p className="font-medium">Não foi possível mostrar {titulo ?? 'esta parte'} agora.</p>
          <p>
            {recarregar
              ? 'O sistema foi atualizado. Recarregue a página para continuar.'
              : 'O resto do sistema continua funcionando.'}
            {!recarregar && aoErro && ' Já fomos avisados do problema.'}
          </p>
        </div>
        {recarregar ? (
          <button className="underline" onClick={() => window.location.reload()} type="button">
            Recarregar a página
          </button>
        ) : (
          <button className="underline" onClick={() => this.setState({ erro: null })} type="button">
            Tentar de novo
          </button>
        )}
      </Alert>
    );
  }
}
